import React from "react"
import PropTypes from "prop-types"

import PeakUsageGraph from "../PeakUsageGraph"

import "./UsageSnapshotCard.scss"

const UsageSnapshotCard = ({ peakUsageTrend }) => {
  return (
    <div className="UsageSnapshotCard">
      <PeakUsageGraph
        maxInEntityCount={100} // Instead of graphing the peak usage as a count, we're actually graphing it as a percentage of all assets over time. Hence, the max is 100%.
        timeslices={peakUsageTrend}
        notEnoughData={!peakUsageTrend || peakUsageTrend.length === 0}
      />
    </div>
  )
}

UsageSnapshotCard.propTypes = {
  peakUsageTrend: PropTypes.array,
}

export default UsageSnapshotCard
